import React from "react";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";

const useQuizDrawer = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [courseData, setCourseData] = React.useState<any>(null);
  const [treeData, setTreeData] = React.useState<any>([]);
  const [isTreeLoading, setIsTreeLoading] = React.useState<boolean>(false);
  const fetchCourseData = async (url: string) => {
    const newURL = url;
    setIsLoading(true);
    getAPIRequest({
      url: newURL,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes } = response || {};
        setCourseData(dataRes);
        setIsLoading(false);
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const fetchTreeData = async (url: string) => {
    const newURL = url;
    setIsTreeLoading(true);
    getAPIRequest({
      url: newURL,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes } = response || {};
        setTreeData(dataRes);
        setIsTreeLoading(false);
        return Promise.resolve(dataRes);
      },
      failure: (err: any) => {
        console.log(err);
        return Promise.resolve([]);
      },
    });
    setIsTreeLoading(false);
  };
  return {
    fetchCourseData,
    isLoading,
    courseData,
    treeData,
    isTreeLoading,
    fetchTreeData,
    setTreeData,
    setIsTreeLoading,
  };
};

export default useQuizDrawer;
